<template>
  <div class="layout">
    <Layout>
      <Header>
        <div class="header">
          <div class="header_Up">
            <div class="header_Up_Box">              
              <div class="header_Up_ul">
                <ul>
                  <li class="header_Up_img" style="padding: 0;">
                <!-- <img src="../assets/cdms_logo.png" alt /> -->
                <img :src='logoSrc' alt />
              </li>
                  <!-- 首页 -->
                  <li :class="{cur:num == 20}" @click="onTab(20)">
                    <router-link
                      to="/home/index"
                      style="color: #494949;width:100%; height:100%; display: block;"
                    >{{$t('system.home')}}</router-link>
                  </li>
                  <li
                    v-for="(item,index) in data"
                    :class="{cur:index == num}"
                    @click="onTab(index)"
                  >
                    <span v-if="param==0">{{item.Name}}</span>
                    <span v-if="param==1">{{item.NameEn}}</span>
                  </li>
                </ul>
              </div>
            </div> 
            <div class="user currentVersionNumberCss">
              <div class="versionNumber">
                  <ButtonGroup size="small">
                    <Button class="btn-header"  type="ghost"  @click="goToBridge" style="font-weight: bold; background-color:#0067b4 ;color:white;">Go to Bridge <Icon type="ios-arrow-forward"></Icon></Button>
               
                    
                    <Button class="btn-header" type="ghost" @click="onEdition">
                      <Tooltip>
                        <!-- <Icon type="information-circled"></Icon> -->
                        v.{{currentVersionNumber}}
                        <div slot="content" style="white-space: normal;">
                          <div
                            v-for="item in  modalEditionList"
                            v-if="currentVersionNumber===item.Version"
                            style="width: 380px;white-space: pre-wrap;"
                          >
                            <p v-html="item.UpdateContent" class="updateContent"></p>
                          </div>
                        </div>
                      </Tooltip>
                    </Button>
                    <Button class="btn-header" type="ghost" @click="onLanguage">{{ $t('system.language') }}</Button>
                  </ButtonGroup>
                </div>
            
             <div class="logout" style="margin-right: 18px;">
                  <template>
                    <Dropdown >
                      <a href="javascript:void(0)">
                        {{this.name}}({{this.account}})
                        <Icon type="arrow-down-b"></Icon>
                      </a>
                      <DropdownMenu slot="list">
                        <DropdownItem style="padding-left:10px;">
                          <!-- 退出系统 -->
                          <div @click="onExitSystem">{{ $t('main.mainExitSystem') }}</div>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </template>
                </div>
                </div>
          </div>
          <div class="header_Down_Box" v-if="isShow">
            <div v-for="(itemCon,index) in data" class="header_Down" v-show="index == num">
              <ul>
                <li v-for="(TwoItemCon) in itemCon.ChildrenModules">
                  <router-link :to="TwoItemCon.Route==null?'':TwoItemCon.Route">
                    <span v-if="param==0">{{TwoItemCon.Name}}</span>
                    <span v-if="param==1">{{TwoItemCon.NameEn}}</span>
                  </router-link>
                  <dl class="nav">
                    <dt v-for="(threeitem) in TwoItemCon.ChildrenModules">
                      <router-link :to="threeitem.Route">
                        <span v-if="param==0">{{threeitem.Name}}</span>
                        <span v-if="param==1">{{threeitem.NameEn}}</span>
                      </router-link>
                    </dt>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header_Down_Border" v-if="!isShow"></div>
      </Header>
      <Content class="ivu-row-Bottom-30">
        <div>
          <router-view :key="activeDate"></router-view>
        </div>
      </Content>
      <Modal v-model="modalEditionShow" :title="$t('system.versionHistory')" width="60%">
        <div style="background:#eee;margin:2px" v-for="item in  modalEditionList">
          <Card :bordered="false">
            <p slot="title">v.{{item.Version}}</p>
            <p slot="extra">{{item.CreateTime | formatDate }}</p>
            <p v-html="item.UpdateContent" class="UpdateContentClass"></p>
          </Card>
        </div>
        <div class="ivu-row-Padding-55 ivu-row-Top">
          <Page
            :total="totalCount"
            show-total
            :current="filter.Page"
            :page-size="filter.Per"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          ></Page>
        </div>
        <div slot="footer">
          <Row type="flex" justify="end" :gutter="10">
            <Col span="2.5">
              <Button @click="handleCancel" icon="ios-close-outline">{{$t('system.close')}}</Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </Layout>
  </div>
</template>
<script>
import dayjs from "dayjs";
import logo_Prod from '../assets/cdms_logo.png';
import logo_Test from '../assets/cdms_test_logo.png';
export default {
  data() {
    return {
      cnString: "中 CN",      
      enString: "EN 英",     
      account: "", //登录账号
      name: "", //登录人
      param: 0, //语言切换条件
      activeDate: null, //刷新路由
      num: 20,
      isShow: false,
      data: [],
      modalEditionShow: false,
      modalEditionList: [],
      filter: {
        Page: 1,
        Per: 3
      },
      //总行数
      totalCount: 0,
      currentVersionNumber: "",
      logoSrc: logo_Test,
      bridgeLink : "https://bridge-test.merckgroup.com/"    
    };
  },

  created() {
    //set logo
    this.getLogo();
    //初始化语言
    this.initLanguage();
    //语言切换
    this.languageSwitch();
    this.account = localStorage.getItem("account");
    this.name = localStorage.getItem("name");
    //导航栏样式记录-切换
    if (sessionStorage.sessionStorageNum == null) {
      sessionStorage.sessionStorageNum = 20;
    } else {
      this.num = sessionStorage.sessionStorageNum;
    }
    if (sessionStorage.getItem("sessionStorageNum") == 20) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
    this.initModule();
    this.initVersionNumber();
  },
  methods: {
    getLogo(){
      if(window.location.href.indexOf('cdms.merckgroup.com')>=0 || window.location.href.indexOf('sgsi2w001201')>=0){
      //if(window.location.href.indexOf('localhost')>=0){
        this.logoSrc = logo_Prod;
        this.bridgeLink = "https://bridge.merckgroup.com/login?isFromCDMS=true";
        // 设置生产环境的颜色变量
        document.documentElement.style.setProperty('--table-stripe-bg', '#f8f8f9');
        document.documentElement.style.setProperty('--page-row-bg', '#f2f4f5');
      } 
      else{
        this.logoSrc = logo_Test;
        this.bridgeLink = "https://bridge-test.merckgroup.com/login?isFromCDMS=true";
        document.documentElement.style.setProperty('--table-stripe-bg', '#f7f5f0');
        document.documentElement.style.setProperty('--page-row-bg', '#f7f5f0');
      } 
    },
    initModule() {
      this.data = JSON.parse(localStorage.ModulesData);
    },
    //初始化语言
    initLanguage() {
      this.$i18n.locale =
        localStorage.getItem("currentLanguage") === null
          ? "mergeZH"
          : localStorage.getItem("currentLanguage");
    },
    initVersionNumber() {
      this.$http
        .get(process.env.COREAPI_HOST + "/User/QueryVersionNumber", {
          params: this.filter
        })
        .then(response => {
          this.modalEditionList = response.data.Models;
          this.totalCount = response.data.TotalCount;
          this.currentVersionNumber = response.data.versionNumber;
        });
    },
    changePage(value) {
      this.filter.Page = value;
      this.initVersionNumber();
    },
    changePageSize(value) {
      this.filter.Per = value;
      this.filter.Page = 1;
      this.initVersionNumber();
    },
    onChangeLanguage(value) {
      if (value === undefined) return;
      this.$i18n.locale = value;
      this.$i18n.fallbackLocale = 'mergeZH';
      localStorage.setItem("currentLanguage", value);
      //刷新路由
      this.activeDate = new Date().toLocaleTimeString();
      this.languageSwitch(); //语言切换
    },
    //语言切换
    languageSwitch() {
      if (
        this.$t("system.language") === this.cnString ||
        this.$t("system.language") === "mergeZH"
      ) {
        this.param = 0;
      } else if (
        this.$t("system.language") === this.enString ||
        this.$t("system.language") === "mergeEN"
      ) {
        this.param = 1;
      }
    },
    onLanguage() {
      if (this.$t("system.language") === this.cnString) {
        this.onChangeLanguage("mergeEN");
      } else if (this.$t("system.language") === this.enString) {
        this.onChangeLanguage("mergeZH");
      }
    },
    goToBridge(){
      window.open(this.bridgeLink, '_blank');
    },
    //tab图片切换
    onTab(index) {
      this.num = index;
      if (this.num == 20) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      sessionStorage.setItem("sessionStorageNum", index);
    },
    //退出系统
    onExitSystem() {
      this.$http
        .post(process.env.COREAPI_HOST + "/User/Logout", {
          Account: localStorage.account
        })
        .then(response => {
          localStorage.clear();
          sessionStorage.clear();
          this.$router.replace("/login");
        });
    },
    // 查看版本
    onEdition() {
      this.modalEditionShow = true;
    },
    handleCancel() {
      this.modalEditionShow = false;
    }
  },
  filters: {
    formatDate: function(val) {
      if (val == null || val == undefined) {
        return "";
      }
      return dayjs(val).format("YYYY-MM-DD");
    }
  }
};
</script>
<style>
.currentVersionNumberCss {
  max-width: 400px !important;
} 
.ivu-tooltip-inner {
  max-width: 400px !important;
  line-height: 1;
} 
</style>
<style scoped>
.updateContent {
  height: 280px;
  overflow: auto;
}
.updateContent::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
ul {
  list-style: none;
}
/*header_Up*/
.ivu-layout-header {
  padding: 0 !important;
  height: auto !important;
  line-height: 50px;
}
/*头部*/
.header {
  width: 100%;  
}

.header > .header_Up {
  width: 100%;
  padding: 0 5px;
  margin: 0 auto;
  position: relative;
  background: #fff;
}
.header > .header_Up > .header_Up_Box {  
  max-width: 77%;
  display: flex;
  min-height: 50px;
}
.header > .header_Up > .header_Up_Box .header_Up_img {
  display: inline-block;
  height: 50px;
  width: 220px;
}
.header > .header_Up > .header_Up_Box .header_Up_img > img {
  padding: 5px 0;
  display: block;
  width: auto;
  height: 100%;
}
.header_Up_ul {
  display: inline-block;
  min-width: 250px;
  float: right;
}

.header > .header_Up > .header_Up_Box > .header_Up_ul > ul {
  display: inline-block;
  display: flex;
  justify-content: space-left;
  width: 100%;
  height: 100%;
  flex-flow: wrap;
}

.header > .header_Up .header_Up_Box > .header_Up_ul > ul > li {
  min-width: 60px;
  padding: 0 15px;
  text-align: center;
  position: relative;
  line-height: 50px;
  cursor: pointer;
  color: #494949;
}

.header > .header_Up > .header_Up_Box > .header_Up_ul ul > li:hover {
  color: #0961a8;
}
.header > .header_Up > .header_Up_Box > .header_Up_ul ul > li.cur:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -17.5px;
  width: 35px;
  height: 5px;
  background: #0067b4;
}
/*有内容样式*/
.header_Down_Box {
  width: 100%;
  padding: 0 40px;
  /*height: 40px;*/
  background: #0067b4;
}
.header_Down ul {
  /*height: 40px;*/
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  width: 100%;
}

.header_Down ul li {
  widows: 90px;
  padding: 0 10px;
  position: relative;
  color: #fff;
  line-height: 20px;
  cursor: pointer;
}

.header_Down ul li:hover {
  background: #4590cd;
}

.header_Down ul li:hover .nav {
  display: block;
}
.header_Down ul li a {
  color: #fff;
  display: block;
  height: 40px;
  line-height: 40px;
}
.header_Down ul li .nav {
  /*display: block;*/
  min-width: 160px;
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #4590cd;
  z-index: 1000;
}

.header_Down ul li .nav dt {
  display: block;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}
.header_Down ul li .nav dt a {
  color: #fff;
}
.header_Down ul li .nav dt:hover {
  background: #0067b4;
}
.header_Down_Hind {
  display: none;
}
/*无内容样式*/
.header_Down_Border {
  height: 3px;
  width: 100%;
  background: #0067b4;
}
.header .user {
  position: absolute;
  top: 10px;
  right: 0;
  float: right;
  min-width: 120px;
  display: flex;
  flex-flow: wrap;
  max-width :25%;
}
.header .user .versionNumber {
  height: 25px;
  line-height: 25px;
}
.header .user .logout {
  height: 25px;
  line-height: 25px;
  right: 10;
}
/* header 区域按钮统一样式 */
.btn-header {
  height: 25px !important;
  line-height: 25px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
  border-radius: 3px !important;
  margin-right: 2px;
}



.user_Style a {
  color: #494949;
}
.ivu-row {
  height: 50px;
}
</style>
<style>
p.UpdateContentClass > ul {
  padding-left: 5px !important;
}
</style>







// WEBPACK FOOTER //
// src/views/Main.vue